import React from 'react';
import './index.css';

function CircleArrowButton({ onClick, className = '' }) {
  return (
    <button 
      className={`circle-arrow-button ${className}`} 
      onClick={onClick}
      aria-label="查看详情"
    >
      <span className="circle-arrow-icon" style={{ backgroundImage: 'url(/image/白箭头.png)' }}></span>
    </button>
  );
}

export default CircleArrowButton;

